import { getNotesErrorList, getNotesErrorListByError, getRemovedNotesList } from "../../api/list";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

// State interface definition
interface NotesErrorListState {
  NotesErrorList: any[];
  RemovedNotesList: any[];
  isLoading: boolean;
  error: string | null;
}

// Initial state setup
const initialState: NotesErrorListState = {
  NotesErrorList: [],
  RemovedNotesList: [],
  isLoading: false,
  error: null,
};

// Async action to fetch error notes list
export const FetchNotesErrorList = createAsyncThunk(
  "NotesErrorList/fetchErrorNotesList",
  async (params: any, { dispatch, getState }) => {
    try {
      const res: any = await getNotesErrorList(params);
      const state: any = getState();
      const previousErrorNotesList = state.NotesErrorList?.NotesErrorList || []; // Extract the array correctly
      if ([1, undefined].includes(res?.result?.page)) {
        dispatch(getNotesError(res?.result?.data || []));
      } else {
        dispatch(getNotesError([
          ...previousErrorNotesList, // Keep existing data
          ...(res?.result?.data || []), // Append new data
        ]));
      }
      
      return res;
    } catch (error) {
      throw new Error('Error fetching notes error list');
    }
  }
);

export const FetchNotesErrorListByError = createAsyncThunk(
  "NotesErrorList/fetchErrorNotesListByError",
  async (params: any, { dispatch, getState }) => {
    try {
      const res: any = await getNotesErrorListByError(params);

      const state: any = getState();
      const previousErrorNotesList = state.NotesErrorList?.NotesErrorList || [];

      // Backend already handles pagination correctly, so use the data as-is
      const paginatedData = res?.data || [];

      if ([1, undefined].includes(res?.page)) {
        dispatch(getNotesError(paginatedData));
      } else {
        dispatch(getNotesError([
          ...previousErrorNotesList,
          ...paginatedData,
        ]));
      }

      return res;
    } catch (error) {
      throw new Error('Error fetching notes error list');
    }
  }
);


export const FetchRemovedNotesList = createAsyncThunk(
  "NotesErrorList/fetchRemovedNotesList",
  async (params: any, { dispatch, getState }) => {
    try {
      const res: any = await getRemovedNotesList(params);
      const state: any = getState();
      const previousErrorNotesList = state.NotesErrorList?.RemovedNotesList || [];
      if ([1, undefined].includes(res?.page)) {
        dispatch(getRemovedNotes(res?.data || []));
      } else {
        dispatch(getRemovedNotes([
          ...previousErrorNotesList,
          ...(res?.data || []),
        ]));
      }
      
      return res;
    } catch (error) {
      throw new Error('Error fetching notes error list');
    }
  }
);



// Slice to manage NotesErrorList state
const NotesErrorListSlice = createSlice({
  name: 'NotesErrorList',
  initialState,
  reducers: {
    getNotesError(state, action: PayloadAction<any[]>) {
      state.NotesErrorList = action.payload;
    },
    getRemovedNotes(state, action: PayloadAction<any[]>) {
      state.RemovedNotesList = action.payload;
    },
  }
});





export default NotesErrorListSlice.reducer;
export const { getNotesError,getRemovedNotes } = NotesErrorListSlice.actions;
